<template>
  <el-scrollbar :native="false" style="height: 100%">
    <el-main>
      <div class="screen-form search-form-wrap">
        <el-select
          v-model="searchType"
          placeholder="请选择"
          style="width: 140px"
        >
          <el-option
            v-for="item in searchTypeList"
            :key="item.id"
            :label="item.dictionaryName"
            :value="item.id"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="queryText"
          placeholder="请输入搜索内容"
          style="width: 300px; margin: 0 8px"
          @keydown.enter.native="handleSearch(1)"
        ></el-input>
        <el-tooltip
          v-if="searchType !== 6"
          class="item"
          content="系统智能拆词搜索"
          effect="dark"
          placement="top"
        >
          <el-button type="primary" @click="handleSearch(1)"
            >模糊搜索</el-button
          >
        </el-tooltip>
        <el-tooltip
          class="item"
          content="与输入内容完全匹配搜索"
          effect="dark"
          placement="top"
        >
          <el-button
            style="background-color: #f67b14"
            type="warning"
            @click="handleSearch(2)"
            >精确搜索</el-button
          >
        </el-tooltip>
      </div>
      <div class="screen-form">
        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">公告类型</div>
          <ul class="screening-conditions announcement-type clear-fix">
            <li
              v-for="(item, index) in announcementOptions"
              :key="item"
              :class="{ active: chooseAnnouncementIndex.includes(index) }"
              class="left"
              @click="chooseMultiple('chooseAnnouncementIndex', index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">采购方式</div>
          <ul class="screening-conditions purchase-type clear-fix">
            <li
              v-for="(item, index) in purchaseOptions"
              :key="item"
              :class="{ active: choosePurchaseIndex.includes(index) }"
              class="left"
              @click="chooseMultiple('choosePurchaseIndex', index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">省份</div>
          <ul class="screening-conditions purchase-type clear-fix">
            <li
              v-for="(item, index) in provincesOptions"
              :key="item"
              :class="{ active: chooseProvincesIndex.includes(index) }"
              class="left"
              @click="chooseMultiple('chooseProvincesIndex', index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">采购人类型</div>
          <ul class="screening-conditions purchase-type clear-fix">
            <li
              v-for="(item, index) in purchaserOptions"
              :key="item"
              :class="{ active: choosePurchaserIndex.includes(index) }"
              class="left"
              @click="chooseMultiple('choosePurchaserIndex', index)"
            >
              {{ item }}
            </li>
          </ul>
        </div>
        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">时间</div>
          <div class="time-wrap">
            <span
              :class="{ active: timeType === -1 }"
              class="all-text"
              @click="timeChange($event, -1)"
              >不限</span
            >
            <div
              :class="{ 'active-time-type': timeType === 'timeMonth' }"
              :style="{ '--bgColor': getTimeTypeBgColor('timeMonth') }"
              class="time-type-style"
            >
              <el-select
                v-model="timeMonth"
                placeholder="请选择月"
                size="mini"
                style="width: 150px"
                @change="timeChange($event, 'timeMonth')"
              >
                <el-option
                  v-for="item in timeMonthList"
                  :key="item.timeDesc"
                  :label="item.timeDesc"
                  :value="item.timeDesc"
                ></el-option>
              </el-select>
            </div>
            <div
              :class="{ 'active-time-type': timeType === 'timeQuarter' }"
              :style="{ '--bgColor': getTimeTypeBgColor('timeQuarter') }"
              class="time-type-style"
            >
              <el-select
                v-model="timeQuarter"
                placeholder="请选择季度"
                size="mini"
                style="width: 150px"
                @change="timeChange($event, 'timeQuarter')"
              >
                <el-option
                  v-for="item in timeQuarterList"
                  :key="item.timeDesc"
                  :label="item.timeDesc"
                  :value="item.timeDesc"
                ></el-option>
              </el-select>
            </div>
            <div
              :class="{ 'active-time-type': timeType === 'timeYear' }"
              :style="{ '--bgColor': getTimeTypeBgColor('timeYear') }"
              class="time-type-style"
            >
              <el-select
                v-model="timeYear"
                placeholder="请选择年"
                size="mini"
                style="width: 100px"
                @change="timeChange($event, 'timeYear')"
              >
                <el-option
                  v-for="item in timeYearList"
                  :key="item.timeDesc"
                  :label="item.timeDesc"
                  :value="item.timeDesc"
                ></el-option>
              </el-select>
            </div>
            <span
              :class="{ active: timeType === 0 }"
              class="all-text"
              @click="timeChange($event, 0)"
              >自定义时间</span
            >
            <el-date-picker
              v-if="timeType === 0"
              v-model="valueTime"
              :default-time="['00:00:00', '23:59:59']"
              :picker-options="pickerOptions"
              end-placeholder="结束日期"
              range-separator="至"
              size="mini"
              start-placeholder="开始日期"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="handleSelectTime"
            ></el-date-picker>
          </div>
        </div>

        <div class="screen-form-item screening-conditions clear-fix">
          <div class="title left">金额</div>
          <ul class="amount-wrap" style="display: flex">
            <li
              v-for="item in amountList"
              :key="item.id"
              :class="{ active: amountType === item.value }"
              class=""
              @click="chooseAmountType(item)"
            >
              {{ item.text }}
            </li>
            <li v-if="amountType === 0">
              <el-input
                v-model="inputMinFee"
                placeholder="最小金额"
                size="mini"
                style="width: 140px"
                type="text"
              >
              </el-input>
              —
              <el-input
                v-model="inputMaxFee"
                placeholder="最大金额"
                size="mini"
                style="width: 140px"
                type="text"
              >
              </el-input>
              万元
              <el-button size="mini" type="primary" @click="handleConfirmMoney"
                >确定</el-button
              >
            </li>
          </ul>
        </div>
      </div>
      <div class="screen-form table-operation">
        <el-button
          icon="el-icon-delete"
          plain
          type="danger"
          @click="batchDeletion"
          >批量删除</el-button
        >
        <el-button icon="el-icon-plus" plain type="primary" @click="addBid"
          >录入标讯</el-button
        >
        <el-button
          icon="el-icon-download"
          plain
          type="primary"
          @click="requestExportTableTenderingMessage(1)"
        >
          招标类型导出
        </el-button>
        <el-button
          icon="el-icon-download"
          plain
          type="primary"
          @click="exVisible = true"
        >
          中标类型导出
        </el-button>
        <el-button
          icon="el-icon-download"
          plain
          type="primary"
          @click="requestExportTableTenderingMessage(5)"
        >
          采购意向导出
          <el-tooltip
            content="公告类型一般为“采购意向公告”，请按需筛选"
            effect="dark"
            placement="top"
          >
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-button>
        <el-button
          icon="el-icon-download"
          plain
          type="primary"
          @click="requestExportTableTenderingMessage(6)"
        >
          采购公告导出
          <el-tooltip content="" effect="dark" placement="top">
            <div slot="content">
              采购公告一般不会超出以下公告类型，请按需选择：采购需求、公开招标公告、邀请招标公告、<br />谈判公告、磋商公告、询价公告、单一来源公示、其他公告、其他公示
            </div>
            <i class="el-icon-info"></i>
          </el-tooltip>
        </el-button>
        <el-button
          :disabled="multipleSelection.length === 0"
          :type="multipleSelection.length === 0 ? 'info' : 'primary'"
          plain
          @click="handleUpdateES"
        >
          更新ES（技术专用）
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="tenderingList"
        :row-class-name="tableRowClassName"
        style="width: 100%"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection"></el-table-column>
        <!-- 标题 -->
        <el-table-column
          label="标题(点击打开前台)"
          min-width="250"
          prop="title"
        >
          <template slot-scope="scope">
            <div style="cursor: pointer" @click="bidTitleClick(scope.row)">
              {{ scope.row.title }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          v-for="(item, index) in tenderingListTitle"
          :key="index"
          :label="item.name"
          :min-width="item.minWidth || 'auto'"
          :prop="item.propertyName"
          :show-overflow-tooltip="item.showOverflowTooltip"
          :width="item.Width || 'auto'"
        >
          <template
            v-if="
              item.propertyName == 'budgetMoney' ||
              item.propertyName == 'bidMoney' ||
              item.propertyName == 'projectDate'
            "
            slot="header"
          >
            <div>
              <span style="display: inline">{{ item.name }}</span>
              <el-button
                v-if="
                  (item.propertyName == 'budgetMoney' && sortType == 4) ||
                  (item.propertyName == 'bidMoney' && sortType == 3) ||
                  (item.propertyName == 'projectDate' && sortType == 2)
                "
                size="mini"
                type="text"
                @click="sortAction(item.propertyName, 0)"
              >
                ▼
              </el-button>
              <el-button
                v-else
                size="mini"
                style="color: grey"
                type="text"
                @click="sortAction(item.propertyName, 1)"
                >▼
              </el-button>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="附件" width="80">
          <template slot-scope="scope">
            <div v-if="canShowLoadIcon(scope)">
              <el-popover
                content="--"
                placement="top"
                title=""
                trigger="hover"
                width="500"
              >
                <div>
                  <div
                    v-for="(
                      item, index
                    ) in scope.row.esBidAttachmentList.filter(
                      (e) => e.isContent
                    )"
                    :key="item.key"
                    class="attachment"
                  >
                    <el-link
                      type="primary"
                      @click="myHandleDownload(item.fileName)"
                    >
                      {{ index + 1 }}、<span
                        v-html="item.attachmentName"
                      ></span>
                    </el-link>
                    <div
                      v-if="item.attachmentContent"
                      class="three-row"
                      style="color: #999; font-size: 12px"
                      v-html="item.attachmentContent"
                    ></div>
                  </div>
                </div>
                <i
                  slot="reference"
                  class="my_table_icon_style el-icon-paperclip"
                  style="font-size: 20px"
                ></i>
              </el-popover>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="项目编号" prop="projectCode" width="140" />
        <el-table-column
          :show-overflow-tooltip="true"
          label="采购方式"
          prop="purchaseTypeName"
          width="100"
        />
        <el-table-column
          :show-overflow-tooltip="true"
          label="省份"
          prop="province"
          width="100"
        />
        <el-table-column fixed="right" label="操作" width="234">
          <template slot-scope="scope">
            <el-button size="mini" @click="lookAll(scope.row)"
              >查看原文</el-button
            >
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="handleDelete(scope.$index, scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap">
        <el-pagination
          :current-page="currentPage"
          :page-size="listPageSize"
          :page-sizes="[5, 10, 15, 20, 25, 30, 50, 100]"
          :total="listPageTotal"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
      <ExportMore
        :info="this.requestTableParams()"
        :limit="listPageTotal"
        :visible.sync="exVisible"
      />
    </el-main>
  </el-scrollbar>
</template>

<script>
import ExportMore from "@/components/Dialog/ExportMore.vue";
// let announcementOptions = ['需求公告', '资格预审', '招标公告'];
import utils from "@/utils/utils";
import { handleDownload } from "@/components/utilsCompCy/BaseCyUtil";

export default {
  name: "backTenderingMessage",
  components: { ExportMore },
  data() {
    return {
      exVisible: false,
      // method: 1,
      inputProjectName: "",
      inputProjectNumber: "",
      // inputKeyword: '',

      inputProjectId: "",
      multipleSelection: [],
      listPageSize: 10, //单页数据数
      listPageTotal: 0, //总数据数量
      listSize: 10, //总页数
      currentPage: 1, //当前页
      valueTime: [], //日期选择器区间
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const todayZero = new Date(
                new Date(new Date().toLocaleDateString()).getTime()
              );
              const end = new Date();
              //js 取得今天0点：
              const start = todayZero;
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近365天",
            onClick(picker) {
              const end = new Date();
              const startZero = new Date();
              startZero.setTime(startZero.getTime() - 3600 * 1000 * 24 * 365);
              const start = new Date(
                new Date(startZero.toLocaleDateString()).getTime()
              );

              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      inputMinFee: "", //最小金额
      inputMaxFee: "", //最大金额
      announcementOptions: [],
      purchaseOptions: [],
      provincesOptions: [],
      purchaserOptions: [],
      chooseAnnouncementIndex: [0],
      choosePurchaseIndex: [0],
      chooseProvincesIndex: [0],
      choosePurchaserIndex: [0],
      tenderingListTitle: [
        // { name: '标题(点击打开前台)', propertyName: 'title', showOverflowTooltip: false, minWidth: 250 },
        {
          name: "预算金额（万元）",
          propertyName: "budgetMoney",
          showOverflowTooltip: true,
          minWidth: 130,
        },
        {
          name: "中标金额（万元）",
          propertyName: "bidMoney",
          showOverflowTooltip: true,
          minWidth: 130,
        },
        {
          name: "公告类型",
          propertyName: "announcementTypeName",
          showOverflowTooltip: true,
        },
        {
          name: "公告日期",
          propertyName: "projectDate",
          showOverflowTooltip: true,
          minWidth: 130,
        },
        {
          name: "供应商",
          propertyName: "winningBidderAnalyzer",
          showOverflowTooltip: true,
        },
        {
          name: "采购人类型",
          propertyName: "purchaserName",
          showOverflowTooltip: true,
        },
        {
          name: "采购人",
          propertyName: "companyName",
          showOverflowTooltip: true,
        },
        {
          name: "代理机构",
          propertyName: "agencyName",
          showOverflowTooltip: true,
        },
        // {name: '项目编号', propertyName: 'projectCode', showOverflowTooltip: true, minWidth: 140},
      ],
      tenderingList: [],
      /* * new */
      // 搜索类型
      searchType: 1,
      // 搜索类型列表
      searchTypeList: [],
      // 搜索标题
      queryText: "",
      queryTextTemp: "",
      // 搜索方法，1模糊搜索；2精确搜索
      searchMethod: 1,
      // 时间 - 选择的类型  -1：全部  0：自定义
      timeType: 0, //def=-1,//20230109
      // 时间 - 选择月
      timeMonth: "",
      timeMonthList: [],
      // 时间 - 选择季度
      timeQuarter: "",
      timeQuarterList: [],
      // 时间 - 选择年
      timeYear: "",
      timeYearList: [],

      // 金额
      amountType: -1,
      amountList: [
        { value: -1, text: "不限", range: [null, null] },
        { value: 1, text: "100万以下", range: ["0", "100"] },
        { value: 2, text: "100-500万", range: ["100", "500"] },
        { value: 3, text: "500-1000万", range: ["500", "1000"] },
        { value: 4, text: "1000-5000万", range: ["1000", "5000"] },
        { value: 5, text: "5000万-1亿", range: ["5000", "10000"] },
        { value: 6, text: "1亿以上", range: ["10000", null] },
        { value: 0, text: "指定金额", range: ["", ""] },
      ],
      sortType: undefined, //2时间倒序；3中标金额倒序；4预算金额倒序
    };
  },
  async created() {
    await this.getAllTimeSelect();
    this.getQueryBidSearchTypeDictionary();
    await this.getSearchCondition();
  },
  methods: {
    // 查看全文
    lookAll(row) {
      window.open(row.pageUrl);
    },
    // 点击标讯标题
    bidTitleClick(row) {
      if (location.hostname == "localhost") return;

      if (location.hostname.indexOf("dev") !== -1) {
        window.open(`https://devtyzb.caigou2003.com/detail/${row.id}`);
      } else if (window.location.hostname.indexOf("test") !== -1) {
        window.open(`https://testyzb.caigou2003.com/detail/${row.id}`);
      } else {
        window.open(`https://yzb.caigou2003.com/detail/${row.id}`);
      }
    },
    getTimeTypeBgColor(type) {
      return this.timeType === type ? "#dcedff" : "#fff";
    },
    // 搜索按钮点击事件 type 1：模糊搜索 2：精确搜索
    handleSearch(type) {
      this.searchMethod = type;
      this.requestTenderingMessageList();
    },
    // 时间发生改变
    timeChange(e, type) {
      this.timeType = type;
      this.timeYear = "";
      this.timeQuarter = "";
      this.timeMonth = "";
      this[type] = e;
      if ([-1, 0].includes(type)) {
        this.valueTime = [];
      } else {
        let activeTime = this[`${type}List`].find(
          (item) => item.timeDesc === e
        );
        this.valueTime = [activeTime.startTime, activeTime.endTime];
      }
      if (type !== 0) this.requestTenderingMessageList();
    },
    // 选择自定义时间
    handleSelectTime(val) {
      if (val.length !== 2) return;
      this.currentPage = 1;
      this.requestTenderingMessageList();
    },
    // 选择金额
    chooseAmountType({ value, range }) {
      this.amountType = value;
      this.inputMinFee = range[0];
      this.inputMaxFee = range[1];
      if (value !== 0) this.requestTenderingMessageList();
    },
    // 自定义金额
    handleConfirmMoney() {
      if (this.inputMinFee === "") {
        this.$message.warning("最小金额不能为空");
        return;
      }
      if (this.inputMaxFee && this.inputMaxFee * 1 <= this.inputMinFee * 1) {
        this.$message.warning("最大金额不能小于最小金额");
      } else {
        this.requestTenderingMessageList();
      }
    },
    // 更新ES按钮点击事件
    async handleUpdateES() {
      let params = this.multipleSelection.map((item) => item.id);
      let { data, status } = await this.$request.batchUpdateEs(params);
      if (status !== 200) {
        this.$message.error(data);
        return;
      }
      this.$message.success(data);
      await this.requestTenderingMessageList();
    },
    // 获取搜索分类
    getQueryBidSearchTypeDictionary() {
      this.$request.getQueryBidSearchTypeDictionary().then(
        (res) => {
          if (res.status == 200) {
            this.searchTypeList = res.data;
            this.searchTypeList.push({
              id: this.searchTypeList[this.searchTypeList.length - 1].id + 1,
              dictionaryName: "标讯ID",
            });
          } else {
            this.requestError(res.status, res.message);
          }
        },
        (err) => {
          this.requestFail(err);
        }
      );
    },
    // 请求 - 获取全部的筛选时间
    async getAllTimeSelect() {
      // this.valueTime = today365(true, 365);//获得今天时间

      let { data, status } = await this.$request.findAllTime();
      if (status !== 200) return;
      this.timeMonthList = data.monthList;
      this.timeQuarterList = data.quarterList;
      this.timeYearList = data.yearList;

      this.timeMonth = data.monthList[0].timeDesc;
      this.timeType = "timeMonth";
      this.valueTime = [data.monthList[0].startTime, data.monthList[0].endTime];
    },
    // 请求 - 获取标讯筛选项
    async getSearchCondition() {
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.$request.searchCondition().then(
        (res) => {
          if (res.status == 200) {
            res.data.announcements.unshift("全部");
            res.data.purchase.unshift("全部");
            res.data.provinces.unshift("全国");
            res.data.purchaser.unshift("全部");

            this.announcementOptions = res.data.announcements;
            this.purchaseOptions = res.data.purchase;
            this.provincesOptions = res.data.provinces.filter(
              (item) => !/(台湾|香港|澳门)/g.test(item)
            );
            this.purchaserOptions = res.data.purchaser;

            this.requestTenderingMessageList().then(() => {
              loading.close();
            });
          } else {
            this.requestError(res.status, res.message);
          }
        },
        (err) => {
          this.requestFail(err);
        }
      );
    },

    // ******************************
    tableRowClassName(val) {
      let row = val.row;
      if (
        (!row.bidMoney || row.bidMoney >= 10 * 10000) &&
        (!row.budgetMoney || row.budgetMoney >= 10 * 10000) &&
        !row.province
      ) {
        return "dangers-row";
      } else if (
        (!row.bidMoney && !row.budgetMoney) ||
        row.bidMoney >= 10 * 10000 ||
        row.budgetMoney >= 10 * 10000 ||
        !row.province
      ) {
        return "warning-row";
      }
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      //表格选中状态切换
      this.multipleSelection = val;
    },
    handleSizeChange(val) {
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.listPageSize = val;
      this.requestTenderingMessageList().then(() => {
        loading.close();
      });
    },
    handleCurrentChange(val) {
      console.log(1);
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = val;
      this.requestTenderingMessageList(1).then(() => {
        loading.close();
      });
    },

    //根据选定的排序标准对招标消息列表进行排序和过滤
    sortAction(val, isSort) {
      console.debug(val, isSort);
      if (isSort) {
        if (val == "budgetMoney") {
          if (this.sortType == 4) {
            return;
          }
          this.sortType = "4";
        } else if (val == "bidMoney") {
          if (this.sortType == 3) {
            return;
          }
          this.sortType = "3";
        } else if (val == "projectDate") {
          if (this.sortType == 2) {
            return;
          }
          this.sortType = "2";
        } else {
          if (this.sortType == undefined) {
            return;
          }
          this.sortType = undefined;
        }
      } else {
        if (this.sortType == undefined) {
          return;
        }
        this.sortType = undefined;
      }

      this.currentPage = 1;
      this.requestTenderingMessageList();
    },
    /*handleCheckAllChange(val) {
      this.checkAnnouncement.checkedOptions = val ? announcementOptions : [];
      this.checkAnnouncement.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAnnouncement.checkAll = checkedCount === this.checkAnnouncement.options.length;
      this.checkAnnouncement.isIndeterminate = checkedCount > 0 && checkedCount < this.checkAnnouncement.options.length;
    },*/
    /*submitScreen(method) {
      if (method == 1) {
        this.method = 1
      } else if (method == 2) {
        this.method = 2
      }
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      this.currentPage = 1;
      // this.chooseAnnouncementIndex = this.nowChooseAnnouncementIndex;
      // this.choosePurchaseIndex = this.nowChoosePurchaseIndex;
      // this.chooseProvincesIndex = this.nowChooseProvincesIndex;
      // this.choosePurchaserIndex = this.nowChoosePurchaserIndex;
      this.requestTenderingMessageList().then(() => {
        loading.close();
      }, err => {
        console.log(err)
      })
    },*/
    /*chooseAnnouncementSingle(e, index) {//公告类型单选
      this.nowChooseAnnouncementIndex = index;
    },
    choosePurchaseSingle(e, index) {//采购方式单选
      this.nowChoosePurchaseIndex = index;
    },
    chooseProvinceSingle(e, index) {//省份单选
      this.nowChooseProvincesIndex = index;
    },
    choosePurchaserSingle(e, index) {//采购人单选
      this.nowChoosePurchaserIndex = index;
    },*/
    chooseMultiple(type = "chooseAnnouncementIndex", index) {
      //多选示例
      if (index == 0) {
        this[type] = [];
        this[type].push(index);
      } else {
        if (this[type].includes(index)) {
          if (this[type].length === 1) {
            this[type] = [0];
          } else {
            this[type] = this[type].filter(function (ele) {
              return ele != index && ele != 0;
            });
          }
        } else {
          this[type].push(index);
          this[type] = this[type].filter(function (ele) {
            return ele != 0;
          });
        }
      }
      this.requestTenderingMessageList();
    },
    handleEdit(index, row) {
      console.log(index, row);
      let { href } = this.$router.resolve({
        name: "backEditTenderingMessage",
        query: {
          id: row.id,
        },
      });
      window.open(href, "_blank");
    },
    addBid() {
      this.$router.push({
        name: "backAddBid",
      });
    },
    handleDelete(index, row) {
      console.log(index, row);
      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          let loading = this.$loading(this.utils.defaultLoadingOptions);
          this.$request
            .deleteTenderingMessage({
              id: row.id,
            })
            .then(
              (res) => {
                if (res.status == 200) {
                  setTimeout(() => {
                    this.$message({
                      type: "success",
                      message: "删除成功!",
                    });
                    loading.close();
                    this.requestTenderingMessageList();
                  }, 1.3e3);
                } else {
                  this.$message({
                    type: "info",
                    message: "删除失败！",
                  });
                  this.requestError(res.status, res.message);
                }
              },
              (err) => {
                console.log(err);
                loading.close();
                this.requestFail(err);
              }
            );
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //批量删除
    batchDeletion() {
      if (this.multipleSelection.length > 0) {
        this.$confirm("此操作将删除选中的数据, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            let loading = this.$loading(this.utils.defaultLoadingOptions);
            let data = [];
            this.multipleSelection.forEach((item) => {
              data.push(item.id);
            });
            this.$request.batchDeletion(data).then(
              (res) => {
                loading.close();
                if (res.status == 200) {
                  this.$message({
                    type: "success",
                    message: "删除成功!",
                  });
                  this.requestTenderingMessageList();
                } else {
                  this.$message({
                    type: "info",
                    message: "删除失败！",
                  });
                  this.requestError(res.status, res.message);
                }
              },
              (err) => {
                console.log(err);
                loading.close();
                this.requestFail(err);
              }
            );
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$confirm("请至少选中一条数据！", "提示", {
          confirmButtonText: "确定",
          type: "warning",
          showCancelButton: false,
        });
      }
    },
    // 处理获取标讯列表的参数
    requestTableParams() {
      let [announceTypes, purchase, province, purchaser] = [[], [], [], []];
      this.chooseAnnouncementIndex.forEach((item) => {
        if (item !== 0) {
          announceTypes.push(this.announcementOptions[item]);
        } else {
          announceTypes = null;
        }
      });
      this.choosePurchaseIndex.forEach((item) => {
        if (item !== 0) purchase.push(this.purchaseOptions[item]);
        else purchase = null;
      });
      this.chooseProvincesIndex.forEach((item) => {
        if (item !== 0) province.push(this.provincesOptions[item]);
        else province = null;
      });
      this.choosePurchaserIndex.forEach((item) => {
        if (item !== 0) purchaser.push(this.purchaserOptions[item]);
        else purchaser = null;
      });
      let data = {
        announceTypes, //公告类型
        purchase, //购买方式
        purchaser, //购买人
        province, //省份
        queryText: this.queryText ? this.queryText.trim() : null,
        searchType: this.searchType,
        searchMethod: this.searchMethod,
        // id: this.inputProjectId.trim() ? this.inputProjectId.trim() : null,
        // projectName: this.inputProjectName.trim() ? this.inputProjectName.trim() : null,  //项目名称
        // projectNo: this.inputProjectNumber.trim() ? this.inputProjectNumber.trim() : null,  //项目编号
        startDt: this.valueTime && this.valueTime[0] ? this.valueTime[0] : null, //开始时间
        endDt: this.valueTime && this.valueTime[1] ? this.valueTime[1] : null, //结束时间
        startMoney: this.inputMinFee
          ? this.inputMinFee.trim() * 10000 * 100
          : null, //起始金额
        endMoney: this.inputMaxFee
          ? this.inputMaxFee.trim() * 10000 * 100
          : null, //最高金额
        page: this.currentPage,
        size: this.listPageSize,
        sort: this.sortType,
      };
      // data[this.method == 1 ? 'keywords' : 'content'] = this.inputKeyword.trim() ? this.inputKeyword.trim() : null;
      return data;
    },
    // 当type为1时不需要修改页码，如果不为1需要将页码修改为1
    requestTenderingMessageList(type) {
      if (!type) {
        this.currentPage = 1;
      }
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      let data = this.requestTableParams();
      return new Promise((resolve, reject) => {
        this.$request
          .tenderingMessageListNew({
            ...data,
          })
          .then(
            (res) => {
              loading.close();
              resolve(res);
              if (res.status == 200) {
                res.data.list.forEach((item) => {
                  //涉及金额属性转换单位
                  item.bidMoney = item.bidMoney
                    ? (item.bidMoney / 1000000).toFixed(6)
                    : item.bidMoney;
                  item.budgetMoney = item.budgetMoney
                    ? (item.budgetMoney / 1000000).toFixed(6)
                    : item.budgetMoney;
                  item.isModify = item.isModify ? "是" : "否";
                });
                this.tenderingList = res.data.list;
                // 数据最多能查出10000条
                if (res.data.total > 10000) {
                  this.listPageTotal = 10000;
                } else {
                  this.listPageTotal = res.data.total;
                }
                this.queryTextTemp = this.queryText;
              } else {
                this.requestError(res.status, res.message);
              }
            },
            (err) => {
              reject(err);
              this.requestFail(err);
            }
          );
      });
    },
    requestExportTableTenderingMessage(exportType) {
      // 数据超过1000条，不能导出
      if (this.listPageTotal === 10000) {
        this.$message({
          type: "warning",
          message: "单次最多支持导出10000条数据",
        });
        return;
      }
      let loading = this.$loading(this.utils.defaultLoadingOptions);
      let data = this.requestTableParams();
      const fileNameTemplate = {
        1: "招标",
        2: "中标",
        5: "采购意向",
        6: "采购公告",
      };
      this.$request
        .exportTableTenderingMessage({
          ...data,
          exportType,
        })
        .then(
          (res) => {
            console.log("res", res);
            if (res.status) {
              loading.close();
              this.requestError(res.status, res.message);
            } else if (res) {
              loading.close();
              let date = new Date();
              const fileName = `${
                fileNameTemplate[exportType]
              }标讯数据导出-${date.getFullYear()}-${
                date.getMonth() + 1
              }-${date.getDate()}.xlsx`;
              let blob = new Blob([res], {
                type: "application/vnd.ms-excel;charset=UTF-8",
              });
              utils.saveAs(blob, `${fileName}`);
            } else {
              console.log("res", res);
            }
          },
          (err) => {
            this.requestFail(err);
          }
        );
    },
    // 下载附件
    myHandleDownload(fileName) {
      handleDownload(this, fileName);
    },
    canShowLoadIcon(scope) {
      let list = scope.row.esBidAttachmentList;
      return !!(list && list.filter((item) => item.fileName).length > 0);
    },
  },
};
</script>

<style lang="less" scoped>
#container {
  .screen-form {
    &.flex {
      margin-top: 30px;
      margin-bottom: 30px;
    }

    .screen-form-item {
      margin: 0 5px 30px 0;

      // * ----------
      .time-wrap {
        font-size: 14px;

        .time-type-style {
          margin-right: 10px;
          display: inline-block;
          border-radius: 6px;

          /deep/ .el-input--mini .el-input__inner {
            background-color: var(--bgColor);
            // background-color: #dcedff;
          }
        }

        .active-time-type {
          border: 2px solid #42a1ff;
        }

        .all-text {
          margin-right: 10px;
          padding: 3px 10px;
          cursor: pointer;
        }

        .active {
          background-color: #409eff;
          color: #fff;
          .border-radius();
        }
      }

      &.flex {
        display: flex;
        justify-content: space-around;
        align-items: center;
      }

      &.screen-form-btn {
        padding: 20px 100px;
      }

      & > .title {
        width: 100px;
        font-weight: bold;
        cursor: default;
        text-align-last: justify;
        font-size: 14px;
        margin-right: 10px;
        padding: 5px 10px;
      }

      ul.screening-conditions {
        font-size: 14px;
        margin-left: 60px;
        padding-left: 40px;

        & > li {
          margin-right: 10px;
          padding: 5px 10px;
          cursor: pointer;

          &.title {
            width: 60px;
            font-weight: bold;
            cursor: default;
            text-align-last: justify;
          }

          &.active {
            background-color: #409eff;
            color: #fff;
            .border-radius();
          }
        }
      }

      .amount-wrap {
        height: 25px;
        font-size: 14px;
        display: flex;
        align-items: center;

        li {
          margin-right: 10px;
          padding: 5px 10px;
          cursor: pointer;

          &.active {
            background-color: #409eff;
            color: #fff;
            .border-radius();
          }
        }
      }
    }
  }

  .search-form-wrap {
    margin-bottom: 30px;
  }

  .pagination-wrap {
    margin-top: 50px;
  }

  .my_table_icon_style {
    cursor: pointer;
    color: #2b85e4;
  }
}

.attachment + .attachment {
  margin-top: 10px;
}

.three-row {
  display: -webkit-box; //谷歌
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3; //显示几行
  overflow: hidden;
}
</style>
<style lang="less">
.el-table .warning-row {
  background: #ffba88;
}

.el-table .dangers-row {
  background: lightcoral;
}

.my_table_popo_style {
  //overflow: hidden;
  //text-overflow: ellipsis;
  //display: -webkit-box;
  //-webkit-line-clamp: 2;
  //-webkit-box-orient: vertical;
  width: 20em;
  //word-wrap:break-word;
  //word-break:break-all;
  margin-bottom: 15px;
  text-decoration: underline;
  text-decoration-color: #2b85e4;
  color: #2b85e4;
  cursor: pointer;
}
</style>
